module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAP1BMVEVHcExlogiIuSKo0Dpspgymzjmu1D9spgymzjlspgyHuSGmzjlspg1spg1spg2mzjloowmo0Dqr0j2JuiOHuSLHdOFsAAAADnRSTlMAKln18fUmMy/68VZc7OLVPY8AAABSSURBVBjTzc5BFoAgCABRUkqzIiDuf9YWmb2iAzjLvxoY908iBRyqoUM1dijGdOGSW4Gp4gStgW7MD6ae8W9eQmqtFfVgeoUQnRFCdEYIZXZtJwv3DhxjOeACAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/favVerde.png
// module id = 163
// module chunks = 198965021219579 276774946550216